import React, { PropsWithChildren } from "react";
import { format } from "date-fns";
import { useTimeZoneContext } from "../../../../lib/context/TimeZone/TimeZoneContext";
import { useInsightsContext } from "../../Context/InsightsContext";
import { toZonedTime } from "date-fns-tz";
import { trimText } from "../../../../lib/helpers/trimText";
import { getDuration } from "../../../Bookings/lib/datePickerHelper";
import { dateToHoursAndMinutes } from "../../../Bookings/lib/dateInputConvert";
import { useMediaQuery } from "../../../../lib/hooks/useMediaQuery";

import {
  StructureTable,
  StructureTableColumn,
} from "../../../shared/StructureTable/StructureTable";
import { DeskHistoryEventsResponse } from "../../../../api/grpc/insights/insights";
import { HistoryCheckInStatus } from "../../shared/HistoryCheckInStatus/HistoryCheckInStatus";
import { Tooltip } from "../../../shared/Tooltip/Tooltip";

const columns: StructureTableColumn[] = [
  {
    key: "organizer",
    header: "Organizer",
  },
  {
    key: "reservationDate",
    header: "Reservation Date",
  },
  {
    key: "from",
    header: "From",
  },
  {
    key: "until",
    header: "Until",
  },
  {
    key: "duration",
    header: "Duration",
  },
  {
    key: "deskItem",
    header: "Desk",
  },
  {
    key: "checkedIn",
    header: "Checked in",
  },
];

export const DeskHistoryTable = ({
  dataDeskHistory,
}: PropsWithChildren<{
  dataDeskHistory: DeskHistoryEventsResponse;
}>) => {
  const { timeZone } = useTimeZoneContext();
  const smallScreen = useMediaQuery("(max-width: 1200px)");
  const { customerSettings } = useInsightsContext();

  const rows = dataDeskHistory.results.map((item) => {
    const { days, hours, minutes } = getDuration(
      new Date(item.startDate),
      new Date(item.endDate)
    );

    return {
      id: item.id,
      organizer: (
        <h4>
          {customerSettings?.showEventOrganizer ? (
            <Tooltip content={item.organizerName}>
              {trimText(item.organizerName, smallScreen ? 70 : 17)}
            </Tooltip>
          ) : (
            "N/A"
          )}
        </h4>
      ),
      reservationDate: (
        <h4>
          {format(
            toZonedTime(new Date(item.startDate), timeZone),
            "yyyy-MM-dd"
          )}
        </h4>
      ),
      from: (
        <h4>{dateToHoursAndMinutes(new Date(item.startDate), timeZone)}</h4>
      ),
      until: (
        <h4>
          {dateToHoursAndMinutes(new Date(item.endDate), timeZone)}
          {days > 0 && (
            <span>, {format(new Date(item.endDate), "yyyy-MM-dd")}</span>
          )}
        </h4>
      ),
      duration: (
        <h4>
          {`${days ? `${days}d ` : ""}${hours ? `${hours}h ` : ""}${
            minutes ? `${minutes}m` : ""
          }`}
        </h4>
      ),
      deskItem: (
        <h4>
          <Tooltip content={item.deskName}>
            {trimText(item.deskName, smallScreen ? 70 : 15)}
          </Tooltip>
        </h4>
      ),
      checkedIn: <HistoryCheckInStatus checkedIn={item.checkedIn} />,
    };
  });

  return (
    <div className="PeopleTable">
      <StructureTable
        columns={columns}
        rows={rows}
        small
        className="StructureTable--rooms InsightsHistoryTable mt-5"
      />
    </div>
  );
};
